module.exports = __webpack_public_path__ + "static/media/adriano-goncalves-IeHLttCrsXE-unsplash.409aec7e.jpg";